




























import Vue from 'vue'
import CallStatusBox from '@/components/CallStatusBox.vue'
import NewFaceIcon from '@/components/NewFaceIcon.vue'

export default Vue.extend({
  name: 'TopListItem',
  components: {
    CallStatusBox,
    NewFaceIcon
  },
  props: {
    profile: {
      type: Object,
      default: null
    },
    isExchangeMessage: {
      type: Boolean,
      default: false
    }
  },
  data(this: any) {
    return {
      isVisible: true
    }
  }
})
